module.exports = __webpack_public_path__ + "static/img/Tigers.1e179ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tigers.svg
// module id = HOe6
// module chunks = 1